import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/domains/companies/models';
import { SmsService } from 'src/app/domains/sms/services/sms.service';
import { SmsBundleBalance } from 'voxloud-types/dist/models';

@Component({
  selector: 'sms-bundle-balance',
  templateUrl: './sms-bundle-balance.component.html',
  styleUrls: ['./sms-bundle-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmsBundleBalanceComponent implements OnInit, OnDestroy {

  @Input() company: Company | null;
  private subscriptions: Subscription[] = [];
  public smsBalanceLoading: boolean = false;
  public smsBalanceError: boolean = false;
  public bundle: SmsBundleBalance = {
    monthly: {
      balance: 0,
      total: 0,
    },
    one_time: {
      balance: 0
    },
    total: 0
  };

  constructor(public smsService: SmsService, private cdr: ChangeDetectorRef ) { }
  
  ngOnInit() {
    this.getBalance();
  }

  public getBalance(): void {
    if (!this.company?.companyId) return;
    this.smsBalanceLoading = true;
    this.smsBalanceError = false;
    this.subscriptions.push(this.smsService.getSMSBalances(this.company.companyId).subscribe({
      next: (result: SmsBundleBalance) => {
        this.smsBalanceLoading = false;
        this.smsBalanceError = false;
        this.bundle = result;
        this.cdr.detectChanges();
      },
      error: () => {
        this.smsBalanceError = true;
        this.smsBalanceLoading = false;
        this.cdr.detectChanges();
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s?.unsubscribe());
  }
}
